import React,{useState,useEffect} from "react";
import { NavLink } from "react-router-dom";

const Recepients = (props) => {
  const [path, setPath] = useState();
  const[status, setStatus] = useState();
  const [date,setNewDate] = useState();
  
  
  useEffect(() => {
    const newPath = props.status === 'Cancel' ? '/rejection' : null;
    setPath(newPath);
    let status;
    if(props.status === 'Cancelled')
    {
      status ='Cancelled'
      setStatus(status);
    }
    else if (props.status === 'Executed')
    {
      status = 'Executed'
      setStatus(status);
    }
    else{
      status = 'Cancel'
      setStatus(status);
    }
    
    const date = new Date(); 
    date.setTime(props.unlocktime*1000);
    const time = date.toString(); // readeable time format
    setNewDate(time);
   
  }, [props.status]);

  //--------------------------SEND CURRENT CONTRACT ADDRESS TO CANCEL-----------------------------//
   const SendContractAddress=()=>{
      localStorage.setItem('Contracttocancel', props.ContractAddress);
   }
  return (
    <div className="pt-4">
      <div className=" p-4 rounded-md border border-gray-400 hover:shadow-md cursor-pointer ">
      <div className=" grid grid-cols-3 md:grid-cols-4 gap-14 items-center">
        <p className="   text-sm    text-gray-400 overflow-hidden">
         {props.Recipient}
        </p>

        <p className="text-sm text-gray-400 ml-4"> {props.ContractAmount}  </p>

        <p className="text-sm text-gray-400"> {date}</p>
        <div className="flex justify-">
          <center>
         <NavLink to={path}>
         <button onClick={SendContractAddress} className=" border rounded-full  h-10 w-24 bg-slate-600 hover:bg-slate-400  text-sm text-white ml-auto " >
            {status}
          </button>
         </NavLink>
          </center>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Recepients;
